import { render, staticRenderFns } from "./indexDialog.vue?vue&type=template&id=5bd21b7d&scoped=true&"
import script from "./indexDialog.vue?vue&type=script&lang=js&"
export * from "./indexDialog.vue?vue&type=script&lang=js&"
import style0 from "./indexDialog.vue?vue&type=style&index=0&id=5bd21b7d&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd21b7d",
  null
  
)

export default component.exports